var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('qrcode-stream',{on:{"decode":function($event){return _vm.onDecode($event)},"init":function($event){return _vm.onInit($event)}}}),_c('p',{staticClass:"error"},[_vm._v(_vm._s(_vm.error))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }